import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Avatar,
  FormLabel,
  Checkbox,
  IconButton,
  Typography,
  Tooltip,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Phone from "../../assets/images/phone.svg";
import Message from "../../assets/images/message.svg";
import Edit from "../../assets/images/icon_edit.svg";
import Calender from "../../assets/images/calender.svg";
import people from "../../assets/images/people.svg";
import table from "../../assets/images/dining-table.svg";
import calendarR from "../../assets/images/calendarRArw.svg";
import calendarD from "../../assets/images/calendar.svg";
import calendarL from "../../assets/images/calendarLArw.svg";
import rupee from "../../assets/images/rupee.svg";
import Glass from "../../assets/images/glass.svg";
import NoOfNights from "../../assets/images/no_of_nights.svg";
import NoOfChildren from "../../assets/images/no_of_children.svg";
import NoOfAdults from "../../assets/images/no_of_adult.svg";
import ReservationStatus from "../../assets/images/reservation_status.svg";
import RoomNo from "../../assets/images/room_no.svg";
import Style from "./styles/CustomerList.module.css";
import { toast } from "react-toastify";
import {
  convertSimpleDateFormat,
  convertToAMPM,
  formatAMPM,
  formatDatetime,
  addMinutesToTime,
  formatISODateString,
  formatTableNumber,
  maskNumber,
  checkBookingTime,
} from "../../utils";
import { IMAGE_BASE_URL } from "../../config/config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setPreviousScreen,
  setSelectedContacts,
  setSelectedIds,
  setSelectedReservations,
  setRestaurantsList,
} from "../../redux/slices/masterDataSlice";
import { useAuth } from "../../hooks/useAuth";
import { ANONYMOUSE_MOBILE_NO, ENDPOINT, ENDPOINT_MIDDLEWARE, TOAST_CONFIG, USER_TYPE } from "../../config/constants";
import { Encrypt } from "../../Crypto-Helper";
import { MIDDLEWARE_PATCH_MULTIPART, POST_MULTIPART } from "../../services/axiosRequestHandler";
import BookingDetailPopup from "../../components/live-table/BookingDetailPopup";
import ChangeTablePopup from "../../components/live-table/ChangeTablePopup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Style1 from "../liveTable/styles/LiveTable.module.css";
import { TextField, Button } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import dayjs from "dayjs";
import TimeSelector from "../../components/time-selector/TimeSelector";
import { setGlobalLoading } from "../../redux/slices/globalLoaderSlice";

function CustomerList({
  data,
  dashboardActions,
  component,
  showCheckBox,
  birthday,
  anniversary,
  filtered,
  reservationFilter,
  reservation,
  checkInOut,
  reservationExport,
  restaurantsList,
  getData,
  usedin="all"
}) {
  const isMobile = useMediaQuery("(max-width:650px)");
  const { role, logout } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedContacts,
    selectedIds,
    selectedReservationIds,
  } = useSelector((state) => state.masterData);
  const [isArrived, setIsArrived] = useState(data?.isArrived ?? false);
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipTimeout, setTooltipTimeout] = useState(null);

  const [bookedTbl, setBookedTbl] = useState(reservation ? data : null);
  const [showBookingDetailsPopup, setShowBookingDetailsPopup] = useState(false);
  const [restId, setRestId] = useState(null);
  const [restaurantData, setRestaurantData] = useState(null);
  const [restSpending, setRestSpending] = useState([]);
  const [showChangeTablePopup, setShowChangeTablePopup] = useState(false);
  const [layout, setLayout] = useState(null);
  const [date, setDate] = useState(dayjs(new Date()));
  const [currentTime, setCurrentTime] = useState({
    hh: formatAMPM(new Date())?.hours,
    mm: formatAMPM(new Date())?.minutes,
    meridiem: formatAMPM(new Date())?.ampm,
  });
  const [dateError, setDateError] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const hasFetched = useRef(false);
  const [counter, setCounter] = useState(0);
  const isExportRoute = location.pathname.includes("export");
  const isAnonymous = data?.isAnonymous || data?.contactNo === ANONYMOUSE_MOBILE_NO;
  const isDuplicate = data?.isDuplicate || false;

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      getAllRestaurants();
    }
  }, [counter]);

  const fetchData = useCallback(() => {
    if (!hasFetched.current) {
      getAllRestaurants();
      hasFetched.current = true;
    }
  }, [currentTime, restId, date]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (refresh && !hasFetched.current) {
        fetchData();
      }
    }, 2000);

    return () => clearTimeout(debounceTimeout);
  }, [refresh, fetchData]);

  const getAllRestaurants = async (bookingTime) => {
    try {
      const payload = new FormData();
      payload.append(
        "fromTime", bookingTime ||
        `${currentTime.hh}:${currentTime.mm}:00 ${currentTime.meridiem}`
      );
      payload.append(
        "toTime", bookingTime? addMinutesToTime(bookingTime,59) :
        addMinutesToTime(
          `${currentTime.hh}:${currentTime.mm}:00 ${currentTime.meridiem}`,
          restaurantData?.occupancy_time
            ? parseInt(restaurantData?.occupancy_time)
            : 120
        )
      );
      payload.append(
        "bookingDate",
        formatISODateString(new Date(date).toISOString())
      );

      const resp = await POST_MULTIPART(
        ENDPOINT.GET_ALL_RESTAURANTS_LIVE_TABLES,
        payload
      );
      if (resp?.response?.data?.status === 200) {
        dispatch(setRestaurantsList(resp?.response?.data));
      } else if (
        resp?.response?.data?.status === 401 &&
        resp?.response?.data?.message === "User Token Expired"
      ) {
        toast.error("Your session has expired!", TOAST_CONFIG);
        logout();
      } else {
        toast.error(resp?.response?.data?.message, TOAST_CONFIG);
      }
    } catch (error) {
      toast.error(error?.message, TOAST_CONFIG);
    }
  };

  const handleReset = () => {
    setCurrentTime({
      hh: formatAMPM(new Date())?.hours,
      mm: formatAMPM(new Date())?.minutes,
      meridiem: formatAMPM(new Date())?.ampm,
    });
    setDate(dayjs(new Date()));
    setDateError("");
  };

  const slotProps = {
    textField: {
      placeholder: "Date",
      variant: "standard",
      sx: {
        width: "100%",
        "& .MuiInput-underline:before": {
          borderBottom: "2px solid #D9D9D9",
        },
        marginBottom: "20px",
      },
      inputProps: {
        fontSize: "16px",
        fontWeight: "400",
        marginBottom: "5px",
      },
    },
    actionBar: {
      actions: ["accept"],
    },
  };

  useEffect(() => {
    setDate(dayjs(bookedTbl?.booking_date));
    const time = checkBookingTime(bookedTbl?.booking_time)
    setCurrentTime(
      time
        ? {
            hh: time && convertToAMPM(time, true)[0],
            mm: time && convertToAMPM(time, true)[1],
            meridiem:
              time && convertToAMPM(time, true)[2],
          }
        : 
        {
            hh: formatAMPM(new Date())?.hours,
            mm: formatAMPM(new Date())?.minutes,
            meridiem: formatAMPM(new Date())?.ampm,
          }
    );
  }, [bookedTbl]);

  useEffect(() => {
    if (data?.restId) {
      setRestId(data?.restId);
      const rest = restaurantsList?.data?.data?.original?.find(
        (item) => item?.id === data?.restId
      );
      rest && setRestaurantData(rest);
    }
    const restIdx = restaurantsList?.data?.data?.original?.findIndex(
      (r) => r.id === data.restId
    );
    if (restIdx >= 0) {
      const spendingArr = [];
      for (let index = 1; index <= 4; index++) {
        spendingArr.push(
          restaurantsList?.data?.data?.original[restIdx][`spending_${index}`]
        );
      }
      setRestSpending(spendingArr);
    }

    if (restaurantsList?.data?.data?.original?.length) {
      const rest = restaurantsList?.data?.data?.original[0];
      setRestId((prev) => (prev ? prev : rest?.id));
      setRestaurantData((prev) => (prev ? prev : rest));
      setRestSpending((prev) =>
        prev
          ? prev
          : [
              rest?.spending_1,
              rest?.spending_2,
              rest?.spending_3,
              rest?.spending_4,
            ]
      );

      let prevRestIndex = null;
      if (restId) {
        prevRestIndex = restaurantsList?.data?.data?.original?.findIndex(
          (item) => item?.id === restId
        );

        if (prevRestIndex && prevRestIndex >= 0) {
          setLayout(
            JSON.parse(
              restaurantsList?.data?.data?.original[prevRestIndex]?.restroLayout
            )
          );
        } else {
          setLayout(
            JSON.parse(restaurantsList?.data?.data?.original[0]?.restroLayout)
          );
        }
      }
    }
  }, [restaurantsList]);

  useEffect(() => {
    if (data?.isArrived !== undefined) {
      setIsArrived(data?.isArrived);
    }
  }, [data]);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [data]);

  const handleRestaurantOptionPillClick = (
    newRestaurantOption,
    isChangeTable
  ) => {
    setShowBookingDetailsPopup(false);
    setRestId(newRestaurantOption.id);
    setRestaurantData(newRestaurantOption);
    setRestSpending([
      newRestaurantOption?.spending_1,
      newRestaurantOption?.spending_2,
      newRestaurantOption?.spending_3,
      newRestaurantOption?.spending_4,
    ]);
    setLayout(JSON.parse(newRestaurantOption?.restroLayout));
    !isChangeTable && setBookedTbl(null);
  };
  const handleMouseEnter = () => {
    if (isTruncated) {
      setTooltipOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setTooltipOpen(false);
  };

  const handleTouchStart = () => {
    if (isTruncated) {
      setTooltipOpen(true);
    }
  };

  const handleTouchEnd = () => {
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
    }

    const timeoutId = setTimeout(() => {
      setTooltipOpen(false);
    }, 2000);

    setTooltipTimeout(timeoutId);
  };

  const handleDateChange = (date) => {
    setCounter((prevCount) => prevCount + 1);
    setDate(date);
    setDateError("");
  };

  const handleTimeChange = (e) => {
    setCounter((prevCount) => prevCount + 1);
    setCurrentTime((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onChecked = (e, data) => {
    if (e.target.checked) {
      dispatch(setSelectedContacts([...selectedContacts, data.contactNo]));
      dispatch(setSelectedIds([...selectedIds, data.id]));
    } else {
      if (selectedContacts.indexOf(data.contactNo) >= 0) {
        const newList = selectedContacts.filter((no) => no !== data.contactNo);
        dispatch(setSelectedContacts(newList));
      }
      if (selectedIds.indexOf(data.id) >= 0) {
        const newList = selectedContacts.filter((_id) => _id !== data.id);
        dispatch(setSelectedIds(newList));
      }
    }
  };
  const onCheckedReservation = (e, id) => {
    if (e.target.checked) {
      dispatch(setSelectedReservations([...selectedReservationIds, id]));
    } else {
      if (selectedContacts.indexOf(data.contactNo) >= 0) {
        const newList = selectedReservationIds.filter((dt) => dt !== id);
        dispatch(setSelectedReservations(newList));
      }
      if (selectedReservationIds.indexOf(id) >= 0) {
        const newList = selectedReservationIds.filter((_id) => _id !== id);
        dispatch(setSelectedReservations(newList));
      }
    }
  };

  const checkIsSelected = (id) => {
    let result = false;
    if (reservationExport) {
      if (selectedReservationIds?.includes(id)) result = true;
    } else {
      if (selectedContacts?.includes(id)) result = true;
    }
    return result;
  };

  const handleSendMessage = (id) => {
    dispatch(setSelectedContacts([id]));
    navigate("/send-template");
  };

  const handleEditClick = async () => {
    if(data?.isCompleted > 0){ 
      // setConfirm(true)
      return;
    };
    await getAllRestaurants(data.booking_time);
    await setBookedTbl(data);
    setShowBookingDetailsPopup(true);
  };

  const handleAddClick = () => {
    navigate(`/customer-search/anonymous/${Encrypt(data.hotelId)}/${Encrypt(data.reservationId)}`)
  }

  const handleCloseBookingPopup = () => {
    setShowBookingDetailsPopup(false);
    setBookedTbl(null);
    setRestSpending([]);
    setRefresh((prev) => prev + 1);
    getData();
    getAllRestaurants();
  };

  const handleCloseChangeTablePopup = async () => {
    await handleReset();
    setShowChangeTablePopup(false);
    handleCloseBookingPopup();
  };

  const getRestaurentName = (restId) => {
    let name = "";
    let rest = restaurantsList?.data?.data?.original?.filter(
      (r) => r.id === restId
    );
    if (rest && rest?.length) {
      name = rest[0].name;
    }
    return name;
  };

  const handleIsArrived = async (e, data) => {
    setIsArrived(e.target.checked);
    const formData = new FormData();
    formData.append("reservationId", data?.reservationId);
    formData.append("isArrived", e.target.checked ? 1 : 0);
    try {
      dispatch(setGlobalLoading(true));
      const response = await MIDDLEWARE_PATCH_MULTIPART(
        ENDPOINT_MIDDLEWARE.ADD_UPDATE_RESERVATION,
        formData,
        false
      );
      dispatch(setGlobalLoading(false));
      if (response?.response?.data?.status === 200) {
        toast.success(response?.response?.data?.message, TOAST_CONFIG);
      } else if (
        response?.response?.data?.status === 401 &&
        response?.response?.data?.message === "User Token Expired"
      ) {
        logout();
      } else {
        toast.error(response?.response?.data?.message, TOAST_CONFIG);
      }
    } catch (error) {
      toast.error(error?.message, TOAST_CONFIG);
    }
  };

  const handleRedirection=(e)=>{
    e.preventDefault(); // Prevent default link behavior

    if(usedin!=="admin" && data?.isCompleted > 0) {
      setConfirm(true)  } 
   else {
     if(reservationFilter) navigate(`/history/${Encrypt(data.id)}`)
        else navigate(`/customer/edit/${Encrypt(data.id)}`)
    }
  }

  return (
    <div>
      <div
        className={`${
          !isExportRoute ? Style.mainWrapper : Style.adminRemarkWrapper
        } ${Style.mainWrapper}`}
      >
        <div className={Style.CustomerListWrapper} >
        {role === USER_TYPE.MANAGER &&
            showCheckBox &&
            location.pathname !== "/live-table" && (
              <Checkbox
                checked={checkIsSelected(
                  reservationExport ? data?.reservationId : data?.contactNo
                )}
                onChange={(e) => {
                  if (reservationExport)
                    onCheckedReservation(e, data?.reservationId);
                  else
                    onChecked(e, { id: data?.id, contactNo: data?.contactNo });
                }}
                className={Style.checkbox}
                sx={{ pr: 1, mr: 1 }}
              />
            )}
          <Link
            className={`${
              location.pathname === "/live-table"
                ? Style.newCustomerInfoWrapper
                : Style.CustomerInfoWrapper
            } `}
            to={
              reservationFilter
              ? `/history/${Encrypt(data.id)}`
              : isAnonymous
                ? checkInOut
                  ? `/customer-search/anonymous/checkInOut/${Encrypt(data.id)}`
                  : `/customer-search/anonymous/${Encrypt(data.hotelId)}/${Encrypt(data.reservationId)}`
                : `/customer/edit/${Encrypt(data.id)}`
            }
          >
            <Avatar
              variant="square"
              src={
                data?.profileImage
                  ? `${IMAGE_BASE_URL}${data?.profileImage}`
                  : ""
              }
              className={Style.avatar}
              sx={{ borderRadius: "9px", width: "56.25px", height: "56.25px" }}
            />
            <div className={Style.customerDetail}>
              {!isAnonymous && (
                <>
                  {(data?.name || data?.user?.name) && (
                    <FormLabel
                      sx={{ cursor: "pointer" }}
                      className={Style.customerNameLabel}
                    >
                      {data.name || data?.user?.name} {data.lastName || data?.user?.lastName}
                    </FormLabel>
                  )}
                  {(data.contactNo || data?.user?.contactNo) && (
                    <p className={Style.phoneText}>
                      {(role === USER_TYPE.MANAGER || checkInOut)? (data?.contactNo || data?.user?.contactNo) : maskNumber(data?.contactNo || data?.user?.contactNo)}
                    </p>
                  )}
                </>
              )}
              {
                isAnonymous && !checkInOut && 
                <FormLabel
                  sx={{ cursor: "pointer" }}
                  className={Style.customerNameLabel}  
                >
                  Anonymous Customer
                </FormLabel>
              }
              {
                isAnonymous && checkInOut &&
                <>
                  <FormLabel
                    sx={{ cursor: "pointer" }}
                    className={Style.customerNameLabel}  
                  >
                    {`${data?.guest_fname} ${data?.guest_lname}` || 'Anonymous Customer'}
                  </FormLabel>
                  {(data.guest_phone_number) && (
                    <p className={Style.phoneText}>
                      {data?.guest_phone_number}
                    </p>
                  )}
                </>
              }
              {birthday ? (
                <p className={Style.dateText}>
                  {data?.dob ? formatDatetime(data?.dob) : ""}
                </p>
              ) : anniversary ? (
                <p className={Style.dateText}>
                  {data?.anniversaryDate
                    ? formatDatetime(data?.anniversaryDate)
                    : ""}
                </p>
              ) : !checkInOut &&
                !reservation &&
                // data?.created_at && (

                data?.created_at ? (
                <p className={Style.dateText}>
                  {formatDatetime(data?.created_at)}
                </p>
              ) : (
                data?.booking_date && (
                  <div className={Style.label}>
                    <img
                      className={Style.img}
                      src={calendarD}
                      alt="calendar_icon"
                    />
                    <p>{convertSimpleDateFormat(data?.booking_date)}</p>
                  </div>
                )
              )}
              {data?.category?.length > 0 && component !== "whosHere" ? (
                <>
                  <div className={Style.initialWrapper}>
                    {data?.category?.map((cat, innerIndex) => (
                      <p className={Style.textField} key={innerIndex}>
                        {cat.alphabets}
                      </p>
                    ))}
                    {data?.isDnd ? (
                      <p className={`${Style.textField} ${Style.dnd} `}>X</p>
                    ) : null}
                  </div>
                </>
              ) : null}
              {
                <div className={Style.labelWraper}>
                  {data?.booking_time ? (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={calendarR}
                        alt="calendar_icon"
                      />
                      <p>{convertToAMPM(data?.booking_time)}</p>
                    </div>
                  ) : null}
                  {data?.booking_date && reservationExport ? (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={calendarD}
                        alt="calendar_icon"
                      />
                      <p>{convertSimpleDateFormat(data?.booking_date)}</p>
                    </div>
                  ) : null}
                  {data?.peopleCount && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={people}
                        alt="people_icon"
                      />
                      <p>
                        {data?.peopleCount?.toString().length === 1
                          ? `0${data?.peopleCount}`
                          : data?.peopleCount}
                      </p>
                    </div>
                  )}
                  {(data?.tableNumberDetails || data?.pdrNumberDetails) && (
                    <div className={Style.label}>
                      <img
                        style={{ height: "20px" }}
                        className={Style.img}
                        src={table}
                        alt="table_icon"
                      />
                      <p>
                        {formatTableNumber(
                          data?.tableNumberDetails
                            ? data.tableNumberDetails +
                                (data?.pdrNumberDetails
                                  ? `, ${data.pdrNumberDetails}`
                                  : "")
                            : data?.pdrNumberDetails
                        )}
                      </p>
                    </div>
                  )}
                  {data?.spending && (
                    <div className={Style.label}>
                      <img className={Style.img} src={rupee} alt="rupee_icon" />
                      {data?.spending}
                    </div>
                  )}
                </div>
              }

              {/* Check In / Out */}
              {checkInOut && (
                <div className={Style.labelWraper}>
                  {data?.check_in && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={calendarL}
                        alt="message"
                      />
                      {convertSimpleDateFormat(data?.check_in)}
                    </div>
                  )}
                  {data?.check_out && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={calendarR}
                        alt="message"
                      />
                      {convertSimpleDateFormat(data?.check_out)}
                    </div>
                  )}
                  {data?.room_numbers && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={RoomNo}
                        alt="room no"
                        style={{height:15, width:15}}
                      />
                      {data?.room_numbers}
                    </div>
                  )}{data?.no_of_adults > 0 && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={NoOfAdults}
                        alt="no. of adults"
                        style={{height:15, width:15}}
                      />
                      {data?.no_of_adults}
                    </div>
                  )}{data?.no_of_children > 0 && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={NoOfChildren}
                        alt="no. of children"
                        style={{height:15, width:15}}
                      />
                      {data?.no_of_children}
                    </div>
                  )}{data?.no_of_nights > 0 && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={NoOfNights}
                        alt="no. of nights"
                        style={{height:15, width:15}}
                      />
                      {data?.no_of_nights}
                    </div>
                  )}{data?.reservation_status && (
                    <div className={Style.label}>
                      <img
                        className={Style.img}
                        src={ReservationStatus}
                        alt="reservation status"
                        style={{height:15, width:15}}
                      />
                      {data?.reservation_status}
                    </div>
                  )}
                  {isAnonymous && <div className={Style.label} style={{ backgroundColor: 'rgba(255, 123, 0, 0.25)' }}>
                  <p style={{ color: '#FF7B00' }}>Anonymous</p>
                </div>}
                </div>
              )}
              <div className={Style.labelWraper}>
                {/* {reservation ? ( */}
                {data?.restaurantName ? (
                  <div className={Style.label}>
                    <p>{data?.restaurantName}</p>
                  </div>
                ) : data?.restId ? (
                  <div
                    className={
                      isMobile
                        ? Style.label
                        : Style.label + " " + Style.pillWidthMax
                    }
                  >
                    <p>{getRestaurentName(data?.restId)}</p>
                  </div>
                ) : null}
              </div>
              {usedin === 'reservation' && <div className={Style.labelWraper}>
                {isAnonymous && <div className={Style.label} style={{ backgroundColor: 'rgba(255, 123, 0, 0.25)' }}>
                  <p style={{ color: '#FF7B00' }}>Anonymous</p>
                </div>}

                {isDuplicate && <div className={Style.label} style={{backgroundColor:'rgba(244, 0, 0, 0.25'}}>
                  <p style={{ color: '#F40000' }}>Duplicate</p>
                </div>}
              </div>}
            </div>
          </Link>
          <div
            className={Style.iconWrapper}
            style={{ flexDirection: ((role!==USER_TYPE.MANAGER && usedin==="filtered") || (role===USER_TYPE.MANAGER &&(usedin==="reservation"|| usedin==="filtered"))) ? "column" : "row" }}
          >
            {reservationFilter ? (
              <div>
                <div className={Style.iconBox}>
                  <img
                    src={Calender}
                    className={Style.iconImg}
                    alt="calender"
                  />
                  <p className={Style.iconText}>
                    {data?.checkinCount?.length
                      ? data?.checkinCount[0]?.checkinCount?.toString()
                          ?.length === 1
                        ? "0" + data?.checkinCount[0]?.checkinCount
                        : data?.checkinCount[0]?.checkinCount || 0
                      : 0}
                  </p>
                </div>
                <div className={Style.iconBox}>
                  <img src={Glass} className={Style.iconImg} alt="glass" />

                  <p className={Style.iconText}>
                    {data?.reservationCount?.length
                      ? data?.reservationCount[0]?.reservationCount?.toString()
                          ?.length === 1
                        ? "0" + data?.reservationCount[0]?.reservationCount
                        : data?.reservationCount[0]?.reservationCount || 0
                      : 0}
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
            
            {!filtered && location.pathname !== "/live-table" && (
              <div className={Style.iconBoxBtnNew} >
                {(reservation && (role !== USER_TYPE.MANAGER || usedin==="reservation" || reservationFilter)) && (
                  <div className={Style.actionIcons}>
                     <Tooltip
                        title={data?.isCompleted > 0 ? "You cannot edit a completed reservation" : ""}
                        sx={{
                          pointerEvents: "auto !important",
                          cursor: data?.isCompleted > 0 ? "not-allowed !important" : "pointer !important",
                          opacity : data?.isCompleted > 0 ? 0.5 : 1
                        }}
                        placement="top"
                      >
                        <IconButton disabled={data?.isCompleted > 0} onClick={handleEditClick}>
                          <img src={Edit} alt="edit" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={data?.isCompleted > 0 ? "You cannot edit a completed reservation" : ""}
                        placement="top"
                      >
                        <IconButton sx={{ p: 1, cursor: data?.isCompleted > 0 ? "not-allowed" : "pointer" }}>
                          <Checkbox
                            checked={isArrived}
                            disabled={data?.isCompleted > 0}
                            onChange={(e) => handleIsArrived(e, data)}
                            className={reservationFilter > 0 ? '':  Style.checkbox}
                            sx={{ p: 0 }}
                          />
                        </IconButton>
                      </Tooltip>
                  </div>
                )}                
                {((usedin==="filtered" || usedin==='admin') && role === USER_TYPE.MANAGER && !reservationFilter) ?
                <>
                    <IconButton
                      sx={{ p: 1 }}
                      onClick={() => {
                        window?.open(`tel:${data?.contactNo}`);
                      }}
                    >
                      <img src={Phone} alt="phone" />
                    </IconButton>
                    {dashboardActions && role === USER_TYPE.MANAGER && (
                      <IconButton
                        sx={{ p: 1 }}
                        onClick={() => {
                          handleSendMessage(data?.contactNo);
                          dispatch(setPreviousScreen(location.pathname));
                        }}
                      >
                        <img src={Message} alt="message" />
                      </IconButton>
                    )}
                </> :
                <div>
                  {!isAnonymous && 
                  <IconButton
                    sx={{ p: 1 }}
                    onClick={() => {
                      window?.open(`tel:${data?.contactNo}`);
                    }}
                  >
                    <img src={Phone} alt="phone" />
                  </IconButton>}
                  {dashboardActions && role === USER_TYPE.MANAGER && (
                    <IconButton
                      sx={{ p: 1 }}
                      onClick={() => {
                        handleSendMessage(data?.contactNo);
                        dispatch(setPreviousScreen(location.pathname));
                      }}
                    >
                      <img src={Message} alt="message" />
                    </IconButton>
                  )}
                </div>
                }
              </div>
            )}
          </div>
        </div>

        {data?.category?.length > 0 && component === "whosHere" ? (
          <div className={Style.initialWrapper}>
            {data?.category?.map((cat, innerIndex) => (
              <p className={Style.textField} key={innerIndex}>
                {cat.alphabets}
              </p>
            ))}
          </div>
        ) : null}
      </div>

      <div
        className={`${
          role === USER_TYPE.MANAGER && location.pathname != "/live-table"
            ? Style.shiftRightAdmin
            : ""
        } ${role === USER_TYPE.STAFF ? Style.remarkWrapper : ""}
${isExportRoute ? Style.remarkWrapperAdmin : ""} ${Style.remarkWrapper}`}
      >
        <Tooltip
          title={isTruncated ? data?.booking_remark : ""}
          placement="top"
          arrow
          open={tooltipOpen}
        >
          <Typography
            ref={textRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {data?.booking_remark}
          </Typography>
        </Tooltip>
      </div>

      {showBookingDetailsPopup && (
        <BookingDetailPopup
          bookingDetails={bookedTbl}
          setBookedTbl={setBookedTbl}
          open={showBookingDetailsPopup}
          restId={restId}
          restaurant={restaurantData}
          handleClose={handleCloseBookingPopup}
          spendings={restSpending}
          handleChangeTablePopup={setShowChangeTablePopup}
          handleAddClick={handleAddClick}
          isDuplicate={isDuplicate}
          isAnonymous={isAnonymous}
        />
      )}

      {showChangeTablePopup && (
        <ChangeTablePopup
          usedin="customerList"
          bookingDetails={bookedTbl}
          layout={layout}
          open={showChangeTablePopup}
          restId={restId}
          handleClose={handleCloseChangeTablePopup}
          restaurantsList={restaurantsList}
          zoomState={0.8}
          handleRestaurantOptionPillClick={handleRestaurantOptionPillClick}
          slotProps={slotProps}
          date={date}
          time={currentTime}
          dateTimeSelector={
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className={Style1.timeWrapper}>
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    Date
                  </p>
                  <MobileDatePicker
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    value={date}
                    // value={dayjs(bookedTbl?.booking_date)}
                    slotProps={slotProps}
                    error={dateError}
                    helperText={dateError}
                    onChange={(newValue) => handleDateChange(newValue)}
                    slots={{
                      textField: (props) => (
                        <TextField
                          {...props}
                          error={dateError}
                          helperText={dateError}
                        />
                      ),
                    }}
                  />
                </div>
              </LocalizationProvider>
              <div className={Style1.timeWrapper}>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Time
                </p>

                <TimeSelector
                  values={currentTime}
                  onChange={handleTimeChange}
                  removeDefault
                />
              </div>
              <Button sx={{ p: 0 }} size="small" onClick={handleReset}>
                Reset
              </Button>
            </>
          }
        />
      )}
      <Dialog open={confirm} onClose={()=>setConfirm(false)}>
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <Typography>
            You cannot edit a completed reservation
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=> setConfirm(false)}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CustomerList;
